import React from 'react';
import { SvgProps } from './icon.types';

function EyeIcon({ title, fillColor = '#2D3049', ...props }: SvgProps) {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M9 4c4.19 0 7.43 4.24 7.57 4.43L17 9l-.54.71C15.85 10.48 12.82 14 9 14c-4.19 0-7.43-4.24-7.57-4.43L1 9l.5-.66C2 7.7 5.1 4 9 4zm0 1.92C6.57 5.92 4.41 7.97 3.48 9l.22.23c1.02 1.08 3.06 2.85 5.3 2.85 2.43 0 4.59-2.05 5.52-3.08-.93-1.03-3.1-3.08-5.52-3.08zm0 .68A2.42 2.42 0 0111.43 9c0 1.33-1.1 2.4-2.43 2.4A2.42 2.42 0 016.58 9c0-1.33 1.08-2.4 2.42-2.4zm0 1.92a.48.48 0 00-.48.48.48.48 0 00.97 0A.48.48 0 009 8.52z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { EyeIcon };
